import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getThemeFromProfile } from '../../styles/theme';

/**
 * CustomThemeProvider component that applies the theme based on store profile
 * Sets the data-theme attribute on the root element for CSS variable switching
 */
const CustomThemeProvider = ({ children }) => {
  const { profile } = useSelector((state) => state.profile);

  useEffect(() => {
    const theme = getThemeFromProfile(profile);
    
    // Set the data-theme attribute on the root element
    if (theme.name === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    
    // Optional: Set a class on the body for additional styling
    document.body.className = theme.name === 'dark' ? 'theme-dark' : 'theme-cherry';
    
    // Set status bar color for mobile devices based on theme's primary color
    let metaThemeColor = document.querySelector("meta[name='theme-color']");
    if (!metaThemeColor) {
      metaThemeColor = document.createElement("meta");
      metaThemeColor.name = "theme-color";
      document.head.appendChild(metaThemeColor);
    }
    metaThemeColor.content = theme.colors.primaryColor || '#f91944';
    
  }, [profile]);

  return <>{children}</>;
};

export default CustomThemeProvider;

